module.exports = __webpack_public_path__ + "static/media/IMG_0068.f838ae5b.JPG";